import React, { Component } from 'react';
import strings from '../locales/';
import TitleMain from '../common/titleMain';
import Label from '../common/label';
import CircularIndicator from '../common/indicators/circularIndicator';
import constants from '../../containers/function/constants';

class TodayFlowsStatsBlock extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showYesterdayFlowsEdit: false
    };
  }

  handleYesterdayFlowsEdit = e => {
    this.setState({
      showYesterdayFlowsEdit: !this.state.showYesterdayFlowsEdit
    });
  };

  render() {
    var noFlowRequestsRisk = this.props.data.noFlowRequestsRisk;

    if(this.props.saveStats 
      && this.props.saveStats.response 
      && this.props.saveStats.response.noFlowRequestsRisk) {
        noFlowRequestsRisk = this.props.saveStats.response.noFlowRequestsRisk;
    }

    return (
      <div className={this.props.className}>
        <TitleMain title={"Indicadores"} />
        <div className="summary-wrapper">
          <div className="summary-block morning-stat">
            <Label 
              label={"AM"} 
              className={"stat-title"}
            />
            <CircularIndicator
              id={"morning-stat"}
              size={92}
              max={100}
              value={this.props.statsTotals.morningFlows}
              forceValue={100}
              fill={true}
              thickness={4}
              valueFormat={{ type: 'NUMBER', format: '.0f' }}
            />
            <Label 
              label={"Planificados ayer" + ": " + this.props.data.morningFlowsPlannedYesterday + " flujos"}
              className={"detail"}
            />
            <div className={"box-form"}>
              <div className={'normal_button'} onClick={this.handleYesterdayFlowsEdit}>
                <div>{"Editar"}</div>
              </div>
              <div>
                <input
                  data-update="morningFlowsInput"
                  data-updatetotal="morningFlows"
                  autoComplete="off"
                  type="text"
                  id="yesterday-flows-input"
                  value={this.props.dataInputs.morningFlowsInput}
                  className={"modal-input" + ((!this.state.showYesterdayFlowsEdit)? " hide" : "")}
                  onChange={this.props.handleChange}
                />
              </div>
            </div>
          </div>
          <div className="summary-block day-stat">
            <Label 
              label={"DÍA"} 
              className={"stat-title"}
            />
            <CircularIndicator
              id={"day-stat"}
              size={92}
              max={100}
              value={this.props.statsTotals.dayFlows}
              forceValue={100}
              fill={true}
              thickness={4}
              valueFormat={{ type: 'NUMBER', format: '.0f' }}
            />
            <Label 
              label={"Ingresa Valores"}
              className={"detail"}
            />
            <div className={"box-form"}>
              <div>
                <input
                  data-update="dayFlowsAscendsInput"
                  data-updatetotal="dayFlows"
                  autoComplete="off"
                  type="text"
                  id="day-ascends-input"
                  value={this.props.dataInputs.dayFlowsAscendsInput}
                  className={"modal-input"}
                  onChange={this.props.handleChange}
                />
                <Label 
                  label={"Subida"}
                  className={"input-detail"}
                />
              </div>
              <div>
                <input
                  data-update="dayFlowsDescendsInput"
                  data-updatetotal="dayFlows"
                  autoComplete="off"
                  type="text"
                  id="day-descends-input"
                  value={this.props.dataInputs.dayFlowsDescendsInput}
                  className={"modal-input"}
                  onChange={this.props.handleChange}
                />
                <Label 
                  label={"Bajada"}
                  className={"input-detail"}
                />
              </div>
              <div>
                <input
                  data-update="dayFlowsInformedDescendsInput"
                  data-updatetotal="dayFlows"
                  autoComplete="off"
                  type="text"
                  id="night-informed-descends-input"
                  value={this.props.dataInputs.dayFlowsInformedDescendsInput}
                  className={"modal-input"}
                  onChange={this.props.handleChange}
                />
                <Label 
                  label={"B. Inform."}
                  className={"input-detail"}
                />
              </div>
            </div>
          </div>
          <div className="summary-block night-stat">
            <Label 
              label={"NOCHE"} 
              className={"stat-title"}
            />
            <CircularIndicator
              id={"night-stat"}
              size={92}
              max={100}
              value={this.props.data.nightFlows}
              forceValue={100}
              fill={true}
              thickness={4}
              valueFormat={{ type: 'NUMBER', format: '.0f' }}
            />
            <Label 
              label={"Flujos planificados hoy"}
              className={"detail"}
            />
          </div>
          <div className="summary-block total-stat">
            <Label 
              label={"TOTAL"} 
              className={"stat-title"}
            />
            <CircularIndicator
              id={"total-stat"}
              size={92}
              max={100}
              value={this.props.statsTotals.totalFlows}
              forceValue={100}
              fill={true}
              thickness={4}
              valueFormat={{ type: 'NUMBER', format: '.0f' }}
              forceColor={constants.colorRange[noFlowRequestsRisk]}
            />
            <Label 
              label={"Valor máximo" + ": " + this.props.data.maxFlows} 
              className={"detail"}
            />
            <Label 
              label={"Cupos faltantes" + ": " + Math.max(this.props.statsTotals.flowsLeft,0)}
              className={"detail"}
            />
          </div>
          <div className="summary-block next-morning-stat">
            <Label 
              label={"AM (MAÑANA)"} 
              className={"stat-title"}
            />
            <CircularIndicator
              id={"next-morning-stat"}
              size={92}
              max={100}
              value={this.props.data.tomorrowMorningFlows}
              forceValue={100}
              fill={true}
              thickness={4}
              valueFormat={{ type: 'NUMBER', format: '.0f' }}
            />
            <Label 
              label={"Flujos planificados mañana"}
              className={"detail"}
            />
          </div>
        </div>
      </div>     
    );
  }
}

export default TodayFlowsStatsBlock;



// WEBPACK FOOTER //
// ./source/client/components/flow_admin_detail/todayFlowsStatsBlock.jsx